<template lang="html">
	<div class="home-cinema-container container-fluid">
		<slot name="title"></slot>
		<div class="row d-sm-none">
			<div class="col cinema-select" slot="select">
				<select class="form-control custom-select" v-on:change="change_cinema" v-model="cinemaSelected">
					<option v-for="option in selectOptions" v-bind:value="option.value">
						{{ option.text }}
					</option>
				</select>
			</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>

export default {

	data() {
		return {
			cinemaSelected: 'kinepolis',
			selectOptions: [
				{ value: 'kinepolis', text: 'Kinepolis' },
				{ value: 'euroscoop', text: 'Euroscoop' },
				{ value: 'imagix', text: 'Imagix' },
				{ value: 'pathe', text: 'Pathé' },
				{ value: 'ugc', text: 'UGC' },
			]
		}
	},

	mounted() {

	},

	methods: {

		change_cinema: function() {
			for (let el of document.querySelectorAll('.home-cinema-col-card')) {
				el.classList.add("d-none")
				el.classList.add("d-sm-block")
			}
			document.getElementById(this.cinemaSelected).classList.remove("d-none")
		},

	}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CinemaComponent.vue